import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/App.jsx'
import '@/index.css'
import { initAccessibility } from '@/lib/accessibility'

// Apply saved accessibility prefs before first render
initAccessibility()

ReactDOM.createRoot(document.getElementById('root')).render(
  <App />
)